import React from "react";
import "../assets/styles/HomePage.css";



function Impressum() {
  return (
  <>

    <div className="home-page">

    

      <div className="recommended-use-cases">
        <h1>Impressum / Imprint</h1>
        <p>Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.</p>
      
        <p style={{ lineHeight: '1.5rem' }}>
            <strong>Firmenname</strong>: Empirisch Tech GmbH <br/>
            <strong>Rechtsform</strong>: Gesellschaft mit beschränkter Haftung (GmbH) <br/>
            <strong>Firmenaddresse</strong>: Rennweg 88, 1030 Wien, Österreich <br/>
            <strong>Unternehmensgegenstand</strong>: IT Consulting <br/>
            <strong>UID-Nummer</strong>: ATU 776 77 257 <br/>
            <strong>Firmenbuchnummer</strong>: FN 566531 i <br/>
            <strong>Firmenbuchgericht</strong>: Handelsgericht Wien <br/>
            <strong>Firmensitz</strong>: Vienna <br/><br/>
            <strong>Tel</strong>: 43-1-2396082 <br/>
            <strong>Email</strong>: <a style={{textDecoration: "none", color: "#f1c40f"}} href="https://chaperoneai.net/contact" target="_blank" rel="noopener noreferrer"> Contact Form</a> <br/><br/>
            <strong>Mitglied bei</strong>: WKO <br/>
            <strong>Verleihungsstaat</strong>: Austria <br/>
            <strong> Geschäftsführer</strong>: Dr. Wasif Masood <br/>
        </p>
        <hr/>
        <p style={{ lineHeight: '1.5rem' }}>
            <strong>Company Name</strong>: Empirisch Tech GmbH <br/>
            <strong>Legal Form</strong>: Limited Liability (Ltd./GmbH) <br/>
            <strong>Company Address</strong>: Rennweg 88, 1030 Wien, Österreich <br/>
            <strong>Object of the Company</strong>: IT Consulting <br/>
            <strong>VAT-Number</strong>: ATU 776 77 257 <br/>
            <strong>Corporate Register Number</strong>: FN 566531 i <br/>
            <strong>Corporate Register Court</strong>: Handelsgericht Wien <br/>
            <strong>Company Location</strong>: Vienna <br/><br/>
            <strong>Tel</strong>: 43-1-2396082 <br/>
            <strong>Email</strong>: <a style={{textDecoration: "none", color: "#f1c40f"}} href="https://chaperoneai.net/contact" target="_blank" rel="noopener noreferrer"> Contact Form</a> <br/><br/>
            <strong>Member of</strong>: WKO <br/>
            <strong>Awarding Country</strong>: Austria <br/>
            <strong>Chief Executive</strong>: Dr. Wasif Masood <br/>
        </p>

      </div>
    </div>
    
    </>
  );
}

export default Impressum;
